import { RECEIVE_PUBLIC_DATA, RECEIVE_PUBLIC_UNIT_TYPES_DATA } from "./actions";
import { updateArrayState } from "../../utils/updateArrayState";
import Immutable from "seamless-immutable";
import { unifyDate } from "phyzzi.com-frontend-utils";

const initialState = {
  lastUpdate: 0,
  data: Immutable([])
};

function unitTypeReducers(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PUBLIC_DATA:
      if (action.json.unit_types) {
        return Object.assign({}, state, {
          lastUpdate: unifyDate(action.json.unit_types.lastUpdate),
          data: updateArrayState(state.data, action.json.unit_types.data)
        });
      }
      return state;
    case RECEIVE_PUBLIC_UNIT_TYPES_DATA:
      return Object.assign({}, state, {
        lastUpdate: unifyDate(action.json.lastUpdate),
        data: updateArrayState(state.data, action.json.data)
      });
    default:
      return state;
  }
}

export default unitTypeReducers;
